module.exports = __webpack_public_path__ + "static/media/error-404.74926dac.svg";